var React = require('react');
var { createElement: h, useState } = React;
var { getJsonNodeLabel, getJsonNodeSummary, getAutoExpandedPickerRoot } = require('./JsonTreeViewer');

function summarizeVal(val) {
  if (val === null) return 'null';
  if (val === undefined) return '\u2014';
  if (Array.isArray(val)) return '[' + val.length + ']';
  if (typeof val === 'object') return '{' + Object.keys(val).length + '}';
  var s = String(val);
  return s.length > 20 ? s.slice(0, 20) + '\u2026' : s;
}

function PropPickerNode(props) {
  var label = props.label;
  var value = props.value;
  var path = props.path;
  var depth = props.depth || 0;
  var onSelect = props.onSelect;
  var [open, setOpen] = useState(depth < 1);

  var isObj = value !== null && value !== undefined && typeof value === 'object';
  var isArr = Array.isArray(value);
  var keys = isObj ? Object.keys(value) : [];
  var indent = depth * 14;
  var displayLabel = getJsonNodeLabel(label, depth, isArr);

  if (!isObj) {
    return h('button', {
      className: 'pp-row pp-row-leaf',
      style: { paddingLeft: indent + 'px' },
      onClick: function() { onSelect(path); }
    },
      h('span', { className: 'pp-toggle-spacer' }),
      label != null ? h('span', { className: 'pp-key' }, displayLabel) : null,
      label != null ? h('span', { className: 'pp-separator' }, ':') : null,
      h('span', { className: 'pp-val' }, summarizeVal(value))
    );
  }

  if (label == null && depth === 0) {
    return h('div', { className: 'pp-group' },
      keys.map(function(k) {
        var childPath = path ? path + '.' + k : k;
        return h(PropPickerNode, {
          key: k, label: k, value: value[k], path: childPath, depth: depth + 1, onSelect: onSelect
        });
      })
    );
  }

  return h('div', { className: 'pp-group' },
    h('div', {
      className: 'pp-row pp-row-branch',
      style: { paddingLeft: indent + 'px' }
    },
      h('button', {
        type: 'button',
        className: 'pp-toggle-btn',
        onClick: function(e) {
          e.stopPropagation();
          setOpen(function(v) { return !v; });
        },
        'aria-label': open ? 'Collapse ' + displayLabel : 'Expand ' + displayLabel,
        title: open ? 'Collapse' : 'Expand'
      }, open ? '-' : '+'),
      h('button', {
        className: 'pp-select-btn',
        onClick: function() { onSelect(path); }
      },
        h('span', { className: 'pp-key' }, displayLabel),
        h('span', { className: 'pp-preview' }, getJsonNodeSummary(isArr, keys.length))
      )
    ),
    open ? (isArr ? [renderArrayLengthRow(path, value.length, depth + 1, onSelect)] : []).concat(
      keys.map(function(k) {
        var childPath = path ? path + '.' + k : k;
        return h(PropPickerNode, {
          key: k, label: k, value: value[k], path: childPath, depth: depth + 1, onSelect: onSelect
        });
      })
    ) : null
  );
}

function renderArrayLengthRow(parentPath, lengthValue, depth, onSelect) {
  var lengthPath = parentPath ? parentPath + '.length' : 'length';
  return h('button', {
    key: '__length__',
    className: 'pp-row pp-row-leaf pp-row-length',
    style: { paddingLeft: (depth * 14) + 'px' },
    onClick: function() { onSelect(lengthPath); },
    title: 'Use the array length (number of items)'
  },
    h('span', { className: 'pp-toggle-spacer' }),
    h('span', { className: 'pp-key' }, 'length'),
    h('span', { className: 'pp-separator' }, ':'),
    h('span', { className: 'pp-val' }, String(lengthValue))
  );
}

function PropPicker(props) {
  var output = props.output;
  var onSelect = props.onSelect;
  var onClose = props.onClose;
  var position = props.position;
  var pickerRoot = getAutoExpandedPickerRoot(output);
  var rootValue = pickerRoot.value;
  var rootPathPrefix = pickerRoot.pathPrefix;
  var rootIsArray = Array.isArray(rootValue);
  var rootIsObject = !rootIsArray && rootValue !== null && rootValue !== undefined && typeof rootValue === 'object';

  return h('div', {
    className: 'prop-picker-balloon',
    style: { left: (position ? position.left : 0) + 'px', top: (position ? position.top : 0) + 'px' },
    onMouseDown: function(e) { e.stopPropagation(); }
  },
    h('div', { className: 'prop-picker-header' },
      h('span', { className: 'prop-picker-title' }, 'Choose value'),
      h('button', { className: 'prop-picker-close', onClick: onClose }, '\u00d7')
    ),
    h('div', { className: 'prop-picker-list' },
      h('button', {
        className: 'pp-row pp-row-full',
        onClick: function() { onSelect(null); }
      },
        h('span', { className: 'pp-toggle-spacer' }),
        h('span', { className: 'pp-key pp-key-full' }, 'Full output'),
        h('span', { className: 'pp-val' },
          rootIsArray
            ? rootValue.length + ' items'
            : rootIsObject
              ? Object.keys(rootValue).length + ' fields'
              : summarizeVal(rootValue)
        )
      ),
      rootIsArray ? renderArrayLengthRow(rootPathPrefix, rootValue.length, 1, onSelect) : null,
      h(PropPickerNode, { label: null, value: rootValue, path: rootPathPrefix, depth: 0, onSelect: onSelect })
    )
  );
}

module.exports = PropPicker;
